import { useSelector } from 'react-redux';
import { get, first } from 'lodash';

export const useAuthenticatedMember = () => {
    return useSelector((state) => first(get(state, 'memberDetails.loginMember', [])));
};
